import { render, staticRenderFns } from "./Turmacrud24.vue?vue&type=template&id=b36bd3e8&"
import script from "./Turmacrud24.vue?vue&type=script&lang=js&"
export * from "./Turmacrud24.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports